import authService from "@/services/auth.service";

export default {
  namespaced: true,
  state: {
    currentUser: null
  },
  mutations: {
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
    }
  },
  actions: {
    async loadCurrentUser({ commit, state }) {
      let currentUser = state.currentUser;
      if (!currentUser) {
        currentUser = await authService.getCurrentUser();
        commit("setCurrentUser", currentUser);
      }
      return currentUser;
    },
    async isAuthenticated({ dispatch }) {
      return null != (await dispatch("loadCurrentUser"));
    },
    async authenticate({ commit, dispatch }, { email, password }) {
      let authenticatedUser = null;
      try {
        authenticatedUser = await authService.authenticate({ email, password });
      } catch (e) {
        dispatch("alerts/notifyError", { code: e.code }, { root: true });
      }

      commit("setCurrentUser", authenticatedUser);
    },
    async logout({ commit, dispatch }) {
      try {
        await authService.logout();
        commit("setCurrentUser", null);
      } catch (e) {
        dispatch("alerts/notifyError", { code: e.code }, { root: true });
      }
    }
  },
  getters: {}
};
